import { newRidgeState } from "react-ridge-state";
// https://github.com/web-ridge/react-ridge-state

export const attemptingAuthorizationState = newRidgeState<boolean>(false);
